<script>
	import { slugify } from "cando-util";
	import Form from "./FormSubmission/Form.svelte";

	export let lang;
	export let data;
	export let col;
	export let settingId;
	export let preview = false;
	export let allowReset = true;
	export let allowHideTags = true;
	export let previewSectionKey;
	export let previewColumns;

	$: pathParts = data?.url?.pathname?.split("/").filter(Boolean) || [];
	$: pathCol = decodeURIComponent(pathParts.at(-2) || "");
	$: pathSettingId = decodeURIComponent(pathParts.at(-1) || "");
	$: hasPathForm = !!data.content?.[pathCol]?.[pathSettingId];
	$: formCol = hasPathForm ? pathCol : col;
	$: formSettingId = hasPathForm ? pathSettingId : settingId;

	$: formId =
		data.content?.[formCol]?.[formSettingId]?.general?.value?.id?.value ||
		`${slugify(formCol)}-${slugify(formSettingId)}-form`;
	$: daisyuiTheme =
		data.content?.[formCol]?.[formSettingId]?.classes?.value?.daisyuiTheme
			?.value || "";
	$: containerClass =
		data.content?.[formCol]?.[formSettingId]?.classes?.value?.containerClass
			?.value || "";
	$: contentClass =
		data.content?.[formCol]?.[formSettingId]?.classes?.value?.contentClass
			?.value || `max-w-[1440px] mx-auto px-2 sm:px-4`;
</script>

<section id={formId} data-theme={daisyuiTheme} class={containerClass}>
	<div class={contentClass}>
		<Form
			{lang}
			{preview}
			settingId={formSettingId}
			{data}
			col={formCol}
			{allowReset}
			{allowHideTags}
			{previewSectionKey}
			{previewColumns}
		/>
	</div>
</section>
